import ChartRingkasanDonut from '@/components/ChartRingkasanDonut';
import { getDashbordCounters } from '@/services/dashboard';
import { getOrderInsight, getTagihanInsight } from '@/services/insight';
import Insight from '@/types/Insight';
import { Skeleton } from 'antd';
import { useEffect, useState } from 'react';

export default function HalamanDashboard() {
  const [counters, setCounters] = useState<{
    loading: boolean;
    data: {
      konsumen: number;
      marketing: number;
      produk: number;
    };
  }>({
    loading: true,
    data: {
      konsumen: 0,
      marketing: 0,
      produk: 0,
    },
  });
  const [insightPesanan, setInsightPesanan] = useState<{
    loading: boolean;
    data: Array<Insight>;
  }>({ loading: true, data: [] });
  const [insightTagihan, setInsightTagihan] = useState<{
    loading: boolean;
    data: Array<Insight>;
  }>({ loading: true, data: [] });

  useEffect(() => {
    getOrderInsight().then(({ data }) => setInsightPesanan({ data, loading: false }));
    getTagihanInsight().then(({ data }) => setInsightTagihan({ data, loading: false }));
    getDashbordCounters()
      .then(({ data }) => setCounters({ loading: false, data }))
      .finally(() => setCounters((old) => ({ ...old, loading: false })));
  }, []);

  return (
    <section className="p-5">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {counters.loading && (
          <>
            <div>
              <Skeleton.Input className="mb-1" block active />
              <Skeleton.Input active />
            </div>
            <div>
              <Skeleton.Input className="mb-1" block active />
              <Skeleton.Input active />
            </div>
            <div>
              <Skeleton.Input className="mb-1" block active />
              <Skeleton.Input active />
            </div>
          </>
        )}
        {!counters.loading && (
          <>
            <div className="rounded shadow p-3 bg-white">
              <h3 className="text-xl md:text-2xl text-gray-400">Konsumen</h3>
              <span className="font-bold text-3xl md:text-5xl text-color-theme">
                {counters.data.konsumen}
              </span>
            </div>
            <div className="rounded shadow p-3 bg-white">
              <h3 className="text-xl md:text-2xl text-gray-400">Marketing</h3>
              <span className="font-bold text-3xl md:text-5xl text-color-theme">
                {counters.data.marketing}
              </span>
            </div>
            <div className="rounded shadow p-3 bg-white">
              <h3 className="text-xl md:text-2xl text-gray-400">Produk</h3>
              <span className="font-bold text-3xl md:text-5xl text-color-theme">
                {counters.data.produk}
              </span>
            </div>
          </>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
        <div className="relative rounded shadow bg-white p-5">
          <h1 className="text-color-theme text-xl font-bold">Ringkasan Tagihan</h1>
          <ChartRingkasanDonut data={insightTagihan.data} />
        </div>
        <div className="relative rounded shadow bg-white p-5">
          <h1 className="text-color-theme text-xl font-bold">Ringkasan Pesanan</h1>
          <ChartRingkasanDonut data={insightPesanan.data} />
        </div>
      </div>
    </section>
  );
}
